import { Text } from '#app/components/Primitives/Text.js';
import { css, styled } from 'styled-components';

export const StyledLocationText = styled(Text)`
  ${({ theme }) => css`
    max-width: 250px;
    overflow: hidden;

    ${theme.mediaQueries.md} {
      max-width: 350px;
    }
  `}
`;
